import React, { useEffect, useRef, useState } from 'react'
import { useAuthDataContext } from '../../_providers/Auth'
import { useNotificationsContext } from '../../_providers/Notifications'
import { useVoiceCallContext } from '../../_providers/VoiceCall'
import notificationIcon from '../../assets/img/header/icons/notification.png'
import IncommingCall from '../modals/IncommingCall'
import closeIcon from '../../assets/img/icons/close-white.png'
import { trans } from '../../_providers/Translation'

const MAX_NOTIFICATIONS = 4
const NOTIFICATION_TTL = 10000

function NotificationsContainer(props) {

    const auth = useAuthDataContext()
    const notifications = useNotificationsContext()
    const calls = useVoiceCallContext()

    const callModalRef = useRef(null)
    const idRef = useRef(0)

    const [instant, setInstant] = useState([])

    const position = auth.setting('notification_position_id')

    let className = ''
    switch (position) {
        case 'bottom_left':
            className = 'bottom-left'
            break
        case 'bottom_right':
            className = 'bottom-right'
            break
    }

    // Add the latest notification to the stack. We always keep only the newest
    // MAX_NOTIFICATIONS, dropping the oldest, so the list can never grow large
    // enough to overflow the screen - independently of any timers.
    useEffect(() => {

        let notification = notifications.latest

        if (!notification) {
            return
        }

        setInstant(prev => [
            { id: ++idRef.current, text: notification.text, expiresAt: Date.now() + NOTIFICATION_TTL },
            ...prev,
        ].slice(0, MAX_NOTIFICATIONS))

    }, [notifications.latest])

    // Remove expired notifications based on a timestamp instead of a per-item
    // setTimeout. setTimeout/setInterval are throttled (and can be paused
    // entirely) while the browser tab is not focused, which left old
    // notifications stacked on screen. With timestamp-based expiry, the moment
    // the sweep runs again - either on the next interval tick or as soon as the
    // tab regains focus (visibilitychange) - everything already past its TTL is
    // cleared at once.
    useEffect(() => {

        const sweep = () => {
            let now = Date.now()
            setInstant(prev => {
                let next = prev.filter(n => n.expiresAt > now)
                return next.length === prev.length ? prev : next
            })
        }

        const interval = setInterval(sweep, 1000)
        document.addEventListener('visibilitychange', sweep)

        return () => {
            clearInterval(interval)
            document.removeEventListener('visibilitychange', sweep)
        }

    }, [])

    const handleClose = id => {
        setInstant(prev => prev.filter(n => n.id !== id))
    }

    const handleShowCaller = (callId, phone) => {
        let modal = callModalRef.current

        modal.open(phone)

        calls.close(callId)
    }

    return (
        <>

            <IncommingCall
                ref={callModalRef}
            />

            <ul className={['instant-notification-wrapper', className].join(' ')}>
                {instant.map(n =>
                    <li key={'notif-' + n.id} className="notification">
                        <h3>
                            <img src={notificationIcon} alt="icon" />
                            {n.text}
                            <img className="close" src={closeIcon} alt="close" onClick={() => handleClose(n.id)} />
                        </h3>
                    </li>
                )}

                {calls.list.map(c =>
                    <li key={'call-' + c.id} className={`notification pointer ${!c.customer ? 'red' : ''}`} onClick={() => handleShowCaller(c.call_id, c.caller_id)}>
                        <h3>
                            <img src={notificationIcon} alt="icon" />
                            {c.caller_id} ({c.customer ? `${c.customer.name} ${c.customer.lastname}` : trans('random.newCustomer')}) {trans('random.incomingCall')}...
                        </h3>
                    </li>
                )}
            </ul>
        </>
    )

}

export default NotificationsContainer
